export default __webpack_public_path__ + "static/media/headset.b216029a.svg";